/* eslint-disable no-unused-vars */
import {
  salesByDay,
  salesByEvent,
  salesByTicket,
  salesByChannel,
  salesByPaymentMethod,
  salesByPointOfSale,
  salesByProduct,
  discountCoupon,
  cancellation,
  receivables,
  receivablesTotal,
  receivablesBalance,
  receivablesExport,
  sendingPackages,
  detailedSalesByEvent,
  financialReport,
  finalConsumerNF,
  getPointOfSale,
  getEquipments,
  getChannelSales,
  getPaymentMethods,
  getConsumer,
  getRegionais,
  getProductTypes,
  affiliates,
  affiliateDetail,
} from "@/api";

const state = {
  intervalDates: [
    { text: "Dia", value: "date" },
    { text: "Semana", value: "week" },
    { text: "Mês", value: "month" },
    { text: "Personalizado", value: "custom" },
  ],
  equipments: [],
  pointOfSales: [],
  salesByChannelOptions: [],
  paymentMethods: [],
  consumer: [],
  regionais: [],
  productTypes: [],

  dialogAffiliateDetail: false,

  reportsFilter: {
    producerId: null,
  },

  exportCSVLoading: false,
  exportPDFLoading: false,
  salesByDayLoading: false,
  salesFilterLoading: false,
  salesByDay: {
    info: [],
    totals: [],
  },
  salesByEventLoading: false,
  salesByEvent: {
    info: [],
    totals: [],
  },
  salesByTicketLoading: false,
  salesByTicket: {
    info: [],
    totals: [],
  },
  salesByChannelLoading: false,
  salesByChannel: {
    info: [],
    totals: [],
  },
  salesByPaymentMethodLoading: false,
  salesByPaymentMethod: {
    info: [],
    totals: [],
  },
  salesByPointOfSaleLoading: false,
  salesByPointOfSale: {
    info: [],
    totals: [],
  },
  salesByPosDetailLoading: false,
  salesByPosDetail: {
    info: [],
    totals: [],
  },
  salesByProductLoading: false,
  salesByProduct: {
    info: [],
    totals: [],
  },
  discountCouponLoading: false,
  discountCoupon: {
    info: [],
    totals: [],
  },
  sendingPackagesLoading: false,
  sendingPackages: {
    info: [],
    totals: [],
  },
  detailedSalesByEventLoading: false,
  detailedSalesByEvent: {
    info: [],
    totals: [],
  },
  financialReportLoading: false,
  financialReport: {
    info: [],
    totals: [],
  },
  finalConsumerNFLoading: false,
  finalConsumerNF: {
    info: [],
    totals: [],
  },
  cancellationLoading: false,
  cancellation: {
    info: [],
    totals: [],
  },
  receivablesLoading: false,
  receivables: {
    listagem: [],
    totais: [],
    saldos: [],
  },

  affiliatesReportLoading: false,
  affiliatesReport: [],

  affiliateDetailLoading: false,
  affiliateDetail: [],
};

const getters = {
  intervalDates: state => state.intervalDates,
  equipments: state => state.equipments,
  pointOfSales: state => state.pointOfSales,
  paymentMethods: state => state.paymentMethods,
  channelSales: state => state.salesByChannelOptions,
  consumer: state => state.consumer,
  regionais: state => state.regionais,
  productTypes: state => state.productTypes,
  dialogAffiliateDetail: state => state.dialogAffiliateDetail,

  reportsFilter: state => state.reportsFilter,

  exportCSVLoading: state => state.exportCSVLoading,
  exportPDFLoading: state => state.exportPDFLoading,

  allSalesByDay: state => state.salesByDay,
  salesByDayLoading: state => state.salesByDayLoading,

  salesFilterLoading: state => state.salesFilterLoading,

  allSalesByEvent: state => state.salesByEvent,
  salesByEventLoading: state => state.salesByEventLoading,

  allSalesByTicket: state => state.salesByTicket,
  salesByTicketLoading: state => state.salesByTicketLoading,

  allSalesByChannel: state => state.salesByChannel,
  salesByChannelLoading: state => state.salesByChannelLoading,

  allSalesByPaymentMethod: state => state.salesByPaymentMethod,
  salesByPaymentMethodLoading: state => state.salesByPaymentMethodLoading,

  allSalesByPointOfSale: state => state.salesByPointOfSale,
  salesByPointOfSaleLoading: state => state.salesByPointOfSaleLoading,

  allSalesByPosDetail: state => state.salesByPosDetail,
  salesByPosDetailLoading: state => state.salesByPosDetailLoading,

  allSalesByProduct: state => state.salesByProduct,
  salesByProductLoading: state => state.salesByProductLoading,

  allDiscountCoupon: state => state.discountCoupon,
  discountCouponLoading: state => state.discountCouponLoading,

  allSendingPackages: state => state.sendingPackages,
  sendingPackagesLoading: state => state.sendingPackagesLoading,

  allDetailedSalesByEvent: state => state.detailedSalesByEvent,
  detailedSalesByEventLoading: state => state.detailedSalesByEventLoading,

  allFinancialReport: state => state.financialReport,
  financialReportLoading: state => state.financialReportLoading,

  allFinalConsumerNF: state => state.finalConsumerNF,
  finalConsumerNFLoading: state => state.finalConsumerNFLoading,

  allCancellation: state => state.cancellation,
  cancellationLoading: state => state.cancellationLoading,

  allReceivables: state => state.receivables,
  receivablesLoading: state => state.receivablesLoading,

  allAffiliatesReport: state => state.affiliatesReport,
  affiliatesReportLoading: state => state.affiliatesReportLoading,

  allAffiliateDetail: state => state.affiliateDetail,
  affiliateDetailLoading: state => state.affiliateDetailLoading,
};

function fetchData({ commit, apiCall, mutationType, loadingType }, params) {
  commit(loadingType, true);
  const { producerId, ...rest } = params;
  apiCall(producerId, rest).then(response => {
    if (
      (response.data.INFO && response.data.TOTAIS) ||
      (response.data.info && response.data.totais) ||
      (response.data.rows && response.data.totais) ||
      (response.data.infos && response.data.totais) ||
      (response.data.infos && response.data.total)
    ) {
      const info = Object.entries(
        response.data.INFO ||
          response.data.info ||
          response.data.rows ||
          response.data.infos
      ).map(e => e[1]);
      const totals = [
        response.data.TOTAIS || response.data.totais || response.data.total,
      ];
      commit(mutationType, { info, totals });
      commit(loadingType, false);
    } else {
      const info = Object.entries(response.data).map(e => e[1]);
      commit(mutationType, { info });
      commit(loadingType, false);
    }
  });
}

const exportData = async (
  commit,
  apiFunction,
  fileType,
  reportName,
  params,
  disableLoader
) => {
  commit(
    `setExport${fileType.toUpperCase()}Loading`,
    disableLoader ? false : true
  );
  const exportType = fileType.toUpperCase();
  const type = fileType === "csv" ? "text/csv" : "application/pdf";

  try {
    const { producerId, ...rest } = params;
    const response = await apiFunction(producerId, rest, exportType);
    const file = new Blob([response.data], { type });
    const fileURL = URL.createObjectURL(file);
    if (fileType === "csv") {
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      a.href = fileURL;
      a.download = `Relatório ${reportName}`;
      a.click();
      window.URL.revokeObjectURL(fileURL);
    } else window.open(fileURL);
  } catch (error) {
    console.error(`Erro ao exportar dados: ${error.message}`);
  } finally {
    commit(`setExport${fileType.toUpperCase()}Loading`, false);
  }
};

const exportReceivables = async (commit, fileType, reportName, params) => {
  commit(`setExport${fileType.toUpperCase()}Loading`, true);
  const exportType = fileType.toUpperCase();
  const type = fileType === "csv" ? "text/csv" : "application/pdf";

  try {
    const response = await receivablesExport(params, exportType);
    const file = new Blob([response.data], { type });
    const fileURL = URL.createObjectURL(file);
    if (fileType === "csv") {
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      a.href = fileURL;
      a.download = `Relatório ${reportName}`;
      a.click();
      window.URL.revokeObjectURL(fileURL);
    } else window.open(fileURL);
  } catch (error) {
    console.error(`Erro ao exportar dados: ${error.message}`);
  } finally {
    commit(`setExport${fileType.toUpperCase()}Loading`, false);
  }
};

const actions = {
  fetchRegionais({ commit }, params) {
    commit("setSalesByDayLoading", true);
    getRegionais().then(response => {
      commit("setRegionais", response.data);
      commit("setSalesByDayLoading", false);
    });
  },
  fetchConsumerOptions({ commit }, params) {
    const { producerId, ...rest } = params;
    commit("setSalesByPointOfSaleLoading", true);
    getConsumer(producerId, rest).then(response => {
      let allConsumers = response.data.map(item => ({
        ...item,
        nome:
          item.razao_social && item.razao_social.length > 0
            ? item.razao_social
            : item.nome,
      }));
      commit("setConsumer", allConsumers);
      commit("setSalesByPointOfSaleLoading", false);
    });
  },
  fetchPointOfSaleOptions({ commit }, params) {
    const { producerId, ...rest } = params;
    commit("setSalesByPointOfSaleLoading", true);
    getPointOfSale(producerId, rest).then(response => {
      commit("setPointOfSales", response.data);
      commit("setSalesByPointOfSaleLoading", false);
    });
  },
  fetchEquipmentOptions({ commit }, params) {
    const { pointOfSales, ...rest } = params;
    commit("setSalesByPointOfSaleLoading", true);
    getEquipments(params, rest).then(response => {
      commit("setEquipments", response.data);
      commit("setSalesByPointOfSaleLoading", false);
    });
  },
  fetchChannelSalesOptions({ commit }, params) {
    commit("setSalesByChannelLoading", true);
    getChannelSales().then(response => {
      commit("setChannelSales", response.data);
      commit("setSalesByChannelLoading", false);
    });
  },
  fetchPaymentMethodOptions({ commit }, params) {
    commit("setSalesByPaymentMethodLoading", true);
    getPaymentMethods().then(response => {
      const modifiedResponse = response.data.map(item => {
        if (item.key === "QRCODE" && item.value === "QRCODE") {
          return { key: "PIX", value: "QRCODE" };
        }
        return item;
      });
      commit("setPaymentMethod", modifiedResponse);
      commit("setSalesByPaymentMethodLoading", false);
    });
  },
  fetchProductTypes({ commit }) {
    getProductTypes().then(response => {
      commit("setProductTypes", response.data);
    });
  },
  fetchSalesByDay: ({ commit }, params) =>
    fetchData(
      {
        commit,
        apiCall: salesByDay,
        mutationType: "setSalesByDay",
        loadingType: "setSalesByDayLoading",
      },
      params
    ),
  fetchSalesByEvent: ({ commit }, params) =>
    fetchData(
      {
        commit,
        apiCall: salesByEvent,
        mutationType: "setSalesByEvent",
        loadingType: "setSalesByEventLoading",
      },
      params
    ),
  fetchSalesByTicket: ({ commit }, params) =>
    fetchData(
      {
        commit,
        apiCall: salesByTicket,
        mutationType: "setSalesByTicket",
        loadingType: "setSalesByTicketLoading",
      },
      params
    ),
  fetchSalesByChannel: ({ commit }, params) =>
    fetchData(
      {
        commit,
        apiCall: salesByChannel,
        mutationType: "setSalesByChannel",
        loadingType: "setSalesByChannelLoading",
      },
      params
    ),
  fetchSalesByPaymentMethod: ({ commit }, params) =>
    fetchData(
      {
        commit,
        apiCall: salesByPaymentMethod,
        mutationType: "setSalesByPaymentMethod",
        loadingType: "setSalesByPaymentMethodLoading",
      },
      params
    ),
  fetchSalesByPointOfSale: ({ commit }, params) =>
    fetchData(
      {
        commit,
        apiCall: salesByPointOfSale,
        mutationType: "setSalesByPointOfSale",
        loadingType: "setSalesByPointOfSaleLoading",
      },
      params
    ),
  fetchSalesByPosDetail: ({ commit }, params) =>
    fetchData(
      {
        commit,
        apiCall: salesByPointOfSale,
        mutationType: "setSalesByPosDetail",
        loadingType: "setSalesByPosDetailLoading",
      },
      params
    ),
  fetchSalesByProduct: ({ commit }, params) =>
    fetchData(
      {
        commit,
        apiCall: salesByProduct,
        mutationType: "setSalesByProduct",
        loadingType: "setSalesByProductLoading",
      },
      params
    ),
  fetchDiscountCouponReport: ({ commit }, params) =>
    fetchData(
      {
        commit,
        apiCall: discountCoupon,
        mutationType: "setDiscountCoupon",
        loadingType: "setDiscountCouponLoading",
      },
      params
    ),
  fetchSendingPackages: ({ commit }, params) =>
    fetchData(
      {
        commit,
        apiCall: sendingPackages,
        mutationType: "setSendingPackages",
        loadingType: "setSendingPackagesLoading",
      },
      params
    ),
  fetchDetailedSalesByEvent: ({ commit }, params) =>
    fetchData(
      {
        commit,
        apiCall: detailedSalesByEvent,
        mutationType: "setDetailedSalesByEvent",
        loadingType: "setDetailedSalesByEventLoading",
      },
      params
    ),
  fetchFinancialReport: ({ commit }, params) =>
    fetchData(
      {
        commit,
        apiCall: financialReport,
        mutationType: "setFinancialReport",
        loadingType: "setFinancialReportLoading",
      },
      params
    ),
  fetchFinalConsumerNF: ({ commit }, params) =>
    fetchData(
      {
        commit,
        apiCall: finalConsumerNF,
        mutationType: "setFinalConsumerNF",
        loadingType: "setFinalConsumerNFLoading",
      },
      params
    ),
  fetchCancellation: ({ commit }, params) =>
    fetchData(
      {
        commit,
        apiCall: cancellation,
        mutationType: "setCancellation",
        loadingType: "setCancellationLoading",
      },
      params
    ),
  async fetchReceivables({ commit }, params) {
    commit("setReceivablesLoading", true);

    try {
      const [receivablesRes, receivablesTotalRes, receivablesBalanceRes] =
        await Promise.all([
          receivables(params),
          receivablesTotal(params),
          receivablesBalance(params),
        ]);

      commit("setReceivables", {
        listagem: receivablesRes.data,
        totais: [receivablesTotalRes.data],
        saldos: receivablesBalanceRes.data,
      });

      commit("setReceivablesLoading", false);
    } catch (err) {
      console.error(err);
    }
  },
  fetchAffiliates: ({ commit }, params) =>
    fetchData(
      {
        commit,
        apiCall: affiliates,
        mutationType: "setAffiliatesReport",
        loadingType: "setAffiliatesReportLoading",
      },
      params
    ),
  fetchAffiliateDetail: ({ commit }, params) =>
    fetchData(
      {
        commit,
        apiCall: affiliateDetail,
        mutationType: "setAffiliateDetail",
        loadingType: "setAffiliateDetailLoading",
      },
      params
    ),
  async exportSalesByDayCSV({ commit }, params) {
    await exportData(commit, salesByDay, "csv", "Vendas por Dia", params);
  },
  async exportSalesByDayPDF({ commit }, params) {
    await exportData(commit, salesByDay, "pdf", "Vendas por Dia", params);
  },
  async exportPaymentMethodCSV({ commit }, params) {
    await exportData(
      commit,
      salesByPaymentMethod,
      "csv",
      "Vendas por Forma de Pagamento",
      params
    );
  },
  async exportPaymentMethodPDF({ commit }, params) {
    await exportData(
      commit,
      salesByPaymentMethod,
      "pdf",
      "Vendas por Forma de Pagamento",
      params
    );
  },

  //EXPORTAÇÕES PDF E CSV
  async exportSalesByEventCSV({ commit }, params) {
    await exportData(commit, salesByEvent, "csv", "Vendas por Evento", params);
  },
  async exportSalesByEventPDF({ commit }, params) {
    await exportData(commit, salesByEvent, "pdf", "Vendas por Evento", params);
  },
  async exportSalesByTicketCSV({ commit }, params) {
    await exportData(commit, salesByTicket, "csv", "Vendas por Tipo", params);
  },
  async exportSalesByTicketPDF({ commit }, params) {
    await exportData(commit, salesByTicket, "pdf", "Vendas por Tipo", params);
  },
  async exportSalesByChannelCSV({ commit }, params) {
    await exportData(commit, salesByChannel, "csv", "Vendas por Canal", params);
  },
  async exportSalesByChannelPDF({ commit }, params) {
    await exportData(commit, salesByChannel, "pdf", "Vendas por Canal", params);
  },
  async exportSalesByPointOfSaleCSV({ commit }, params) {
    await exportData(
      commit,
      salesByPointOfSale,
      "csv",
      "Vendas por Ponto de Venda",
      params
    );
  },
  async exportSalesByPointOfSalePDF({ commit }, params) {
    await exportData(
      commit,
      salesByPointOfSale,
      "pdf",
      "Vendas por Ponto de Venda",
      params
    );
  },
  async exportSalesByPOSDetailCSV({ commit }, params) {
    await exportData(
      commit,
      salesByPointOfSale,
      "csv",
      "Detalhes de Vendas por Ponto de Venda",
      params,
      true
    );
  },
  async exportSalesByPOSDetailPDF({ commit }, params) {
    await exportData(
      commit,
      salesByPointOfSale,
      "pdf",
      "Detalhes de Vendas por Ponto de Venda",
      params,
      true
    );
  },
  async exportSalesByProductCSV({ commit }, params) {
    await exportData(
      commit,
      salesByProduct,
      "csv",
      "Vendas de Produtos",
      params
    );
  },
  async exportDiscountCouponCSV({ commit }, params) {
    await exportData(
      commit,
      discountCoupon,
      "csv",
      "Cupons de Desconto",
      params
    );
  },
  async exportDiscountCouponPDF({ commit }, params) {
    await exportData(
      commit,
      discountCoupon,
      "pdf",
      "Cupons de Desconto",
      params
    );
  },
  async exportSendingPackagesCSV({ commit }, params) {
    await exportData(
      commit,
      sendingPackages,
      "csv",
      "Envio de Pacotes",
      params
    );
  },
  async exportSendingPackagesPDF({ commit }, params) {
    await exportData(
      commit,
      sendingPackages,
      "pdf",
      "Envio de Pacotes",
      params
    );
  },
  async exportDetailedSalesByEventCSV({ commit }, params) {
    await exportData(
      commit,
      detailedSalesByEvent,
      "csv",
      "Vendas Detalhadas por Evento",
      params
    );
  },
  async exportDetailedSalesByEventPDF({ commit }, params) {
    await exportData(
      commit,
      detailedSalesByEvent,
      "pdf",
      "Vendas Detalhadas por Evento",
      params
    );
  },
  async exportFinancialReportCSV({ commit }, params) {
    await exportData(
      commit,
      financialReport,
      "csv",
      "Relatório Financeiro",
      params
    );
  },
  async exportFinancialReportPDF({ commit }, params) {
    await exportData(
      commit,
      financialReport,
      "pdf",
      "Relatório Financeiro",
      params
    );
  },
  async exportFinalConsumerNFCSV({ commit }, params) {
    await exportData(
      commit,
      finalConsumerNF,
      "csv",
      "Nota Fiscal Consumidor",
      params
    );
  },
  async exportFinalConsumerNFPDF({ commit }, params) {
    await exportData(
      commit,
      finalConsumerNF,
      "pdf",
      "Nota Fiscal Consumidor",
      params
    );
  },
  async exportCancellationCSV({ commit }, params) {
    await exportData(commit, cancellation, "csv", "Cancelamento", params);
  },
  async exportCancellationPDF({ commit }, params) {
    await exportData(commit, cancellation, "pdf", "Cancelamento", params);
  },
  async exportReceivablesCSV({ commit }, params) {
    await exportReceivables(commit, "csv", "Recebíveis", params);
  },
  async exportReceivablesPDF({ commit }, params) {
    await exportReceivables(commit, "pdf", "Recebíveis", params);
  },
  async exportAffiliatesCSV({ commit }, params) {
    await exportData(commit, affiliates, "csv", "Afiliados", params);
  },
  async exportAffiliatesPDF({ commit }, params) {
    await exportData(commit, affiliates, "pdf", "Afiliados", params);
  },
};

const mutations = {
  setDialogAffiliateDetail(state, dialogAffiliateDetail) {
    state.dialogAffiliateDetail = dialogAffiliateDetail;
  },
  setReportsFilter(state, reportsFilter) {
    state.reportsFilter = reportsFilter;
  },
  setRegionais(state, regionais) {
    state.regionais = regionais;
  },
  setConsumer(state, consumer) {
    state.consumer = consumer;
  },
  setPaymentMethod(state, paymentMethods) {
    state.paymentMethods = paymentMethods;
  },
  setEquipments(state, equipments) {
    state.equipments = equipments;
  },
  setPointOfSales(state, pointOfSales) {
    state.pointOfSales = pointOfSales;
  },
  setChannelSales(state, channelSales) {
    state.salesByChannelOptions = channelSales;
  },
  setProductTypes(state, productTypes) {
    state.productTypes = productTypes;
  },
  setExportCSVLoading(state, exportCSVLoading) {
    state.exportCSVLoading = exportCSVLoading;
  },
  setExportPDFLoading(state, exportPDFLoading) {
    state.exportPDFLoading = exportPDFLoading;
  },
  setSalesByDay(state, salesByDay) {
    state.salesByDay = salesByDay;
  },
  setSalesByDayLoading(state, salesByDayLoading) {
    state.salesByDayLoading = salesByDayLoading;
  },
  setSalesFilterLoading(state, salesFilterLoading) {
    state.salesFilterLoading = salesFilterLoading;
  },
  setSalesByEvent(state, salesByEvent) {
    state.salesByEvent = salesByEvent;
  },
  setSalesByEventLoading(state, salesByEventLoading) {
    state.salesByEventLoading = salesByEventLoading;
  },
  setSalesByTicket(state, salesByTicket) {
    state.salesByTicket = salesByTicket;
  },
  setSalesByTicketLoading(state, salesByTicketLoading) {
    state.salesByTicketLoading = salesByTicketLoading;
  },
  setSalesByChannel(state, salesByChannel) {
    state.salesByChannel = salesByChannel;
  },
  setSalesByChannelLoading(state, salesByChannelLoading) {
    state.salesByChannelLoading = salesByChannelLoading;
  },
  setSalesByPaymentMethod(state, salesByPaymentMethod) {
    state.salesByPaymentMethod = salesByPaymentMethod;
  },
  setSalesByPaymentMethodLoading(state, salesByPaymentMethodLoading) {
    state.salesByPaymentMethodLoading = salesByPaymentMethodLoading;
  },
  setSalesByPointOfSale(state, salesByPointOfSale) {
    state.salesByPointOfSale = salesByPointOfSale;
  },
  setSalesByPointOfSaleLoading(state, salesByPointOfSaleLoading) {
    state.salesByPointOfSaleLoading = salesByPointOfSaleLoading;
  },
  setSalesByPosDetail(state, salesByPosDetail) {
    state.salesByPosDetail = salesByPosDetail;
  },
  setSalesByPosDetailLoading(state, salesByPosDetailLoading) {
    state.salesByPosDetailLoading = salesByPosDetailLoading;
  },
  setSalesByProduct(state, salesByProduct) {
    state.salesByProduct = salesByProduct;
  },
  setSalesByProductLoading(state, salesByProductLoading) {
    state.salesByProductLoading = salesByProductLoading;
  },
  setDiscountCoupon(state, discountCoupon) {
    state.discountCoupon = discountCoupon;
  },
  setDiscountCouponLoading(state, discountCouponLoading) {
    state.discountCouponLoading = discountCouponLoading;
  },
  setSendingPackages(state, sendingPackages) {
    state.sendingPackages = sendingPackages;
  },
  setSendingPackagesLoading(state, sendingPackagesLoading) {
    state.sendingPackagesLoading = sendingPackagesLoading;
  },
  setDetailedSalesByEvent(state, detailedSalesByEvent) {
    state.detailedSalesByEvent = detailedSalesByEvent;
  },
  setDetailedSalesByEventLoading(state, detailedSalesByEventLoading) {
    state.detailedSalesByEventLoading = detailedSalesByEventLoading;
  },
  setFinancialReport(state, financialReport) {
    state.financialReport = financialReport;
  },
  setFinancialReportLoading(state, financialReportLoading) {
    state.financialReportLoading = financialReportLoading;
  },
  setFinalConsumerNF(state, finalConsumerNF) {
    state.finalConsumerNF = finalConsumerNF;
  },
  setFinalConsumerNFLoading(state, finalConsumerNFLoading) {
    state.finalConsumerNFLoading = finalConsumerNFLoading;
  },
  setCancellation(state, cancellation) {
    state.cancellation = cancellation;
  },
  setCancellationLoading(state, cancellationLoading) {
    state.cancellationLoading = cancellationLoading;
  },
  setReceivables(state, receivables) {
    state.receivables = receivables;
  },
  setReceivablesLoading(state, receivablesLoading) {
    state.receivablesLoading = receivablesLoading;
  },
  setAffiliatesReport(state, affiliatesReport) {
    state.affiliatesReport = affiliatesReport;
  },
  setAffiliatesReportLoading(state, affiliatesReportLoading) {
    state.affiliatesReportLoading = affiliatesReportLoading;
  },
  setAffiliateDetail(state, affiliateDetail) {
    state.affiliateDetail = affiliateDetail;
  },
  setAffiliateDetailLoading(state, affiliateDetailLoading) {
    state.affiliateDetailLoading = affiliateDetailLoading;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
